import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import ScholarshipProcess from '../../components/sections/ScholarshipProcess';
import ApplicationRequirements from '../../components/sections/ApplicationRequirements';
import SEO from '../../components/common/SEO';

const Scholarships = () => {
  const { t } = useTranslation();

  return (
    <div className="py-12">
      <SEO 
        title={t('seo.scholarshipsTitle')} 
        description={t('seo.scholarshipsDescription')}
      />
      
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            {t('scholarships.title')}
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('scholarships.subtitle')}
          </p>
        </motion.div>
        
        
        

        <ScholarshipProcess />
        <ApplicationRequirements />

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mt-8 bg-blue-50 rounded-xl p-6"
        >
          <h3 className="text-xl font-semibold text-blue-800 mb-3">
            {t('scholarships.deadlineTitle')}
          </h3>
          <p className="text-blue-700 mb-4">
            {t('scholarships.openCallDeadlineText')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            
            <a 
              href="/scholarship-application.pdf" 
              download
              className="inline-block bg-white text-blue-600 border border-blue-600 px-6 py-3 rounded-lg hover:bg-blue-50 transition-colors text-center"
            >
              {t('scholarships.downloadForm')}
            </a>
          </div>
        </motion.div>
        {/* Extra: Open Call Deadline and Decision */}
              <div className="mt-8 p-4 rounded-lg bg-blue-50 text-blue-900">
                <h3 className="text-lg font-semibold mb-1">{t('scholarships.openCallDecisionTitle')}</h3>
                <p>{t('scholarships.openCallDecisionText')}</p>
              </div>
      </div>
    </div>
  );
};

export default Scholarships;